import {applyMiddleware, compose, createStore} from 'redux';
import createSagaMiddleware from 'redux-saga';
import {connectRouter, routerMiddleware} from 'connected-react-router/immutable';
import {createBrowserHistory} from 'history';
// import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';

import reducers from '../reducers';
import sagas from '../sagas';

export default initState => {
	const history = createBrowserHistory();
	const sagaMiddleware = createSagaMiddleware();
	const composeEnhancer = (process.env.NODE_ENV==='development' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

	const middlewares = [
		// Redux middleware that spits an error on you when you try to mutate your state either inside a dispatch or between dispatches.
		// reduxImmutableStateInvariant(),
		sagaMiddleware,
		routerMiddleware(history),
	];

	const store = createStore(
		connectRouter(history)(reducers),
		initState,
		composeEnhancer(applyMiddleware(...middlewares))
	);
	sagaMiddleware.run(sagas);

	return {
		store,
		history
	};
};



// WEBPACK FOOTER //
// ./src/core/configureApp.js